<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="min-width: 600px">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Allocate DDC Controller</div>
        <q-space />
        <q-btn v-close-popup icon="close" flat round dense />
      </q-card-section>

      <q-form @submit="onSubmit">
        <q-card-section>
          <div class="text-subtitle2 q-mb-md">
            Equipment: <strong>{{ formData.equipment_name }}</strong>
          </div>

          <q-select
            :model-value="formData.ddc_panel_id"
            label="DDC Panel *"
            filled
            :options="availableDdcPanels.map(p => ({ label: p.name, value: p.id, panel: p }))"
            emit-value
            map-options
            :rules="[val => !!val || 'DDC Panel is required']"
            class="q-mb-md"
            @update:model-value="emit('update:ddc-panel-id', $event)"
          >
            <template #option="scope">
              <q-item v-bind="scope.itemProps">
                <q-item-section>
                  <q-item-label>{{ scope.opt.panel.name }}</q-item-label>
                  <q-item-label v-if="scope.opt.panel.total_io_points" caption>
                    I/O Capacity: {{ scope.opt.panel.available_io_points || 0 }}/{{ scope.opt.panel.total_io_points }} available
                  </q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>

          <q-checkbox
            :model-value="formData.apply_to_devices"
            label="Apply to all devices in this equipment (cascade)"
            class="q-mb-md"
            @update:model-value="emit('update:apply-to-devices', $event)"
          />

          <q-banner v-if="formData.apply_to_devices" class="bg-info text-white rounded-borders">
            <template #avatar>
              <q-icon name="info" color="white" />
            </template>
            Controller allocation will automatically apply to all devices in this equipment. Devices can be individually overridden later.
          </q-banner>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn v-close-popup flat label="Cancel" color="grey" />
          <q-btn unelevated label="Allocate" type="submit" color="primary" :loading="saving" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    availableDdcPanels: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:ddc-panel-id',
    'update:apply-to-devices',
    'submit',
  ]);

  function onSubmit() {
    emit('submit');
  }
</script>
